import { memo } from "react";
import { Sparkles } from "lucide-react";
import { TierBadge, TIER_META } from "@/components/TierBadge";

function TierRateCardBase({ tier, tierRate }) {
  return (
    <div className="card-surface rounded-sm p-6" data-testid="tier-rate-card">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-4 h-4 text-[#6B0F1A]" strokeWidth={1.75} />
        <h3 className="font-display text-lg font-bold text-[#1A0F0A]">Your Tier</h3>
      </div>
      {tier ? (
        <>
          <div className="flex items-baseline justify-between gap-4">
            <div>
              <div className="font-mono-tag text-[9px] text-[#78584B]">TIER</div>
              <div
                className="font-display text-3xl font-extrabold tracking-tight mt-1"
                style={{
                  color:
                    TIER_META[tier].color === "#B08D57"
                      ? "#B08D57"
                      : TIER_META[tier].color,
                }}
                data-testid="tier-rate-card-tier"
              >
                {TIER_META[tier].label}
              </div>
            </div>
            <div className="text-right">
              <div className="font-mono-tag text-[9px] text-[#78584B]">RATE</div>
              <div
                className="font-display text-3xl font-extrabold tracking-tight text-[#1A0F0A] mt-1"
                data-testid="tier-rate-card-rate"
              >
                ${tierRate ?? TIER_META[tier].rate}
                <span className="text-sm font-semibold text-[#78584B] ml-1">/shoot</span>
              </div>
            </div>
          </div>
          <p className="text-[11px] text-[#78584B] mt-5 leading-relaxed">
            Your tier and per-shoot rate are set by the Reelty team. This updates
            automatically if your tier changes.
          </p>
        </>
      ) : (
        <>
          <div className="flex items-center gap-3">
            <TierBadge tier={null} />
          </div>
          <p className="text-[11px] text-[#78584B] mt-4 leading-relaxed">
            Once you're approved, a Reelty admin will assign your tier and per-shoot rate.
            You'll see it here as soon as it's set.
          </p>
        </>
      )}
    </div>
  );
}

export const TierRateCard = memo(TierRateCardBase);
